import { requestCutoutImage } from '@shakkerai/services';
import { getImageOssPath, getCDNImage } from '@shakkerai/util-image';
import { notifySuccess, notifyError } from '@shakkerai/pro-components';
import { updateElement } from '@starflow/app/helpers/canvas';
import { translate } from '@shakkerai/util-i18n';
import {
  inferenceAPIBucket,
  scheduleLoadImage,
  uploadCanvas,
  extractMaskContent,
  canvasToImage,
  cropTransparentEdge,
} from '@shakkerai/pro-utils';
export const requestCutoutImageFunction = async (element) => {
  try {
    const { images } = await requestCutoutImage({
      images: [getImageOssPath(element.url)],
      mode: 1,
      ...inferenceAPIBucket,
    });

    if (Array.isArray(images) && images[0]) {
      // 去mask之外的
      const removedBackgroundImage = await scheduleLoadImage(getCDNImage(images[0]));
      const noTransparentImageCanvas = cropTransparentEdge(removedBackgroundImage);
      const noTransparentUploadResult = await uploadCanvas(noTransparentImageCanvas);
      updateElement(element?.id, {
        url: noTransparentUploadResult.url,
        width: noTransparentImageCanvas.width,
        height: noTransparentImageCanvas.height,
      });

      notifySuccess(translate('image_cutout_success'));
    } else {
      throw new Error(translate('image_cutout_error'));
    }
  } catch (error) {
    notifyError(translate('image_cutout_error'), translate('image_cutout_error_sub'));
  } finally {
  }
};
